import { tryAxios } from '@/api/common/auth'
import { AttachInfo, DynamicAttachData } from '@/api/common/attach'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/UnitBase`
//#region 基本信息
const GetUnitInfo = (id: number) => `${apiUrl}/${id}`
const ViewUnitInfo = (id: number) => `${apiUrl}/view/${id}`
const PostUnitInfo = `${apiUrl}`
const PutUnitInfo = (id: number) => `${apiUrl}/${id}`
const DeleteUnitFile = (id: number, attachId: number) => `${apiUrl}/DelFile?id=${id}&attachId=${attachId}`
const AuditUnit = (id: number) => `${apiUrl}/audit/${id}`
//组成部分
const GetPartList = (listId: number) => `${apiUrl}/part/${listId}`
const PostPartData = `${apiUrl}/part`
const DeletePart = (id: number) => `${apiUrl}/part/${id}`
//非文保单位
const GetOtherUnit = (id: number) => `${apiUrl}/other/${id}`
const CheckCoord = (lng: number, lat: number) => `${apiUrl}/checkCoord/${lng}/${lat}`
//#endregion
export const emptyOther: UnitOtherData = {
    Id: 0,
    UnitId: 0,
    Tel: '',
    Email: '',
    Contact: '',
    WebUrl: '',
    WeiBo: '',
    WeiXin: '',
    Comments: ''
}
export const emptyData: UnitBaseData = {
    ParentId: 0,
    ParentCode: '',
    ParentName: '',
    //照片和图纸
    HasFiles: true,
    //主要组成
    HasPart: true,
    //所有权及使用情况
    HasOwner: true,
    //四有情况
    HasFour: true,
    //保护规划
    HasPlan: true,
    //保护工程
    HasProject: true,
    //考古调查与发掘
    HasArchaeology: true,
    //安全与执法
    HasSafetyCheck: true,
    //展示利用
    HasExibition: true,
    //视频设备
    HasVideo: true,
    //风险记录
    HasRisk: true,

    AttachTypePic: 0,
    OtherAttachType: 0,
    Pictures: [],
    Drawings: [],
    Status: 0,
    AreaList: [],
    ShowPosition: true,
    EditPosition: true,
    PositionList: [],
    ActionList: [],
    UnitRiskList: [],
    EventRiskList: [],
    ListId: 0,
    IsPart: false,

    IsOtherUnit: false,
    InstituteTypeName: '',
    InstituteLevelName: '',
    OtherInfo: emptyOther,
    OtherDynamicAttachs: [],

    //#region 以下信息在展示的时候显示
    /// <summary>
    /// 文保单位简介汇总
    /// </summary>
    Summary: '',
    CityId: 0,
    CityName: '',
    CountyId: 0,
    CountyName: '',
    LevelName: '',
    ClassifyName: '',
    SubClassifyName: '',
    BatchName: '',
    StatisticAgeName: '',
    SaveTypeName: '',
    SaveStatusName: '',
    UnitPropertyNames: '',
    NaturalDamageNames: '',
    HumanDamageNames: '',
    //#endregion

    Id: 0,
    LevelId: 0,
    HeritageCode: '',
    HeritageName: '',
    HeritageShortName: '',
    PublishClassifyId: 0,
    SubClassifyId: 0,
    SubClassifyOther: '',
    BatchId: 0,
    PublishAge: '',
    StatisticAgeId: 0,
    PublishAddress: '',
    DetailAddress: '',
    BuiltArea: 0,
    FloorArea: 0,
    AreaType: 0,
    AreaCode: '',
    AreaName: '',
    UnitPropertyIds: '',
    StateSummary: '',
    NaturalEnvironment: '',
    SocialEnvironment: '',
    SaveTypeId: 0,
    SaveStatusId: 0,
    SaveDescription: '',
    IsDamage: false,
    NaturalDamageIds: '',
    HumanDamageIds: '',
    DamageDescription: '',
    IsPaintedSculpture: false,
    InstituteTypeId: 0,
    InstituteLevelId: 0,
    InformantName: '',
    InformantUnit: '',
    InformantTel: '',
    InformantEmail: '',
    SequenceId: 0,

    Inactive: false,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),
    //多语言设置
    LangItems: []
}
export const emptyPoint: UnitPositionData = {
    Id: 0,
    HeritageUnitId: 0,
    UnitId: 0,
    PositionType: 0,
    TypeName: '',
    SubSequence: 0,
    SortKey: '',

    PositionName: '',
    HeritageLongitude: 0,
    HeritageLatitude: 0,
    HeritageSeaHeight: 0,
    PositionDesc: '',
    LocationAddress: '',

    LngDegree: 0,
    LngSecond: 0,
    LngMinute: 0,

    LatDegree: 0,
    LatSecond: 0,
    LatMinute: 0,
    //多语言设置
    LangItems: [],

    CoordStatus: 0,
    CoordMessage: '',
    CoordAddress: ''
}
export interface UnitBaseData {
    [key: string]: any
    ParentId: number
    ParentCode: string
    ParentName: string
    //照片和图纸
    HasFiles: boolean
    //主要组成
    HasPart: boolean
    //所有权及使用情况
    HasOwner: boolean
    //四有情况
    HasFour: boolean
    //保护规划
    HasPlan: boolean
    //保护工程
    HasProject: boolean
    //考古调查与发掘
    HasArchaeology: boolean
    //安全与执法
    HasSafetyCheck: boolean
    //展示利用
    HasExibition: boolean
    /**视频设备*/
    HasVideo: boolean
    //风险记录
    HasRisk: boolean

    AttachTypePic: number
    OtherAttachType: number
    Pictures: UnitFileData[]
    Drawings: UnitFileData[]
    Status: number
    AreaList: UnitAreaData[]
    //查看测绘信息
    ShowPosition: boolean
    //编辑测绘信息
    EditPosition: boolean
    PositionList: UnitPositionData[]
    ActionList: UnitActionData[]
    UnitRiskList: any
    EventRiskList: any

    ListId: number
    IsPart: boolean

    //#region 非文保单位
    IsOtherUnit: boolean
    InstituteTypeName: string
    InstituteLevelName: string
    OtherInfo: UnitOtherData
    OtherDynamicAttachs: DynamicAttachData[]
    //#endregion

    //#region 以下信息在展示的时候显示
    /// <summary>
    /// 文保单位简介汇总
    /// </summary>
    Summary: string

    CityId: number
    CityName: string
    CountyId: number
    CountyName: string

    LevelName: string
    ClassifyName: string
    SubClassifyName: string
    BatchName: string
    StatisticAgeName: string
    SaveTypeName: string
    SaveStatusName: string
    UnitPropertyNames: string
    NaturalDamageNames: string
    HumanDamageNames: string
    //#endregion

    Id: number
    LevelId: number
    HeritageCode: string
    HeritageName: string
    HeritageShortName: string
    PublishClassifyId: number // 文物分类
    SubClassifyId: number // 文物子类
    SubClassifyOther: string // 其他类需手动填写
    BatchId: number
    PublishAge: string // 年代
    StatisticAgeId: number // 统计年代
    PublishAddress: string
    DetailAddress: string
    BuiltArea: number
    FloorArea: number
    AreaType: number
    AreaCode: string
    AreaName: string
    UnitPropertyIds: string
    StateSummary: string
    NaturalEnvironment: string
    SocialEnvironment: string
    SaveTypeId: number
    SaveStatusId: number
    SaveDescription: string
    IsDamage: boolean
    NaturalDamageIds: string
    HumanDamageIds: string
    DamageDescription: string
    IsPaintedSculpture: boolean
    InstituteTypeId: number
    InstituteLevelId: number
    InformantName: string
    InformantUnit: string
    InformantTel: string
    InformantEmail: string
    SequenceId: number

    Inactive: boolean
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date
    //多语言设置
    LangItems: any[]
}
export interface UnitFileData {
    [key: string]: any
    Id: number
    UnitId: number
    FileType: number //0:图片 1:图纸
    FileCode: string // 代码
    FileName: string // 名称
    AttachId: number
    FileCreateDate: Date // 制作日期
    FileMade: string // 制作人
    FileSpec: string
    Specification: string
    NewUserId: number
    NewDate: Date

    FileTypeName: string
    AttachType: number
    AttachGuid: string
    AttInfo: AttachInfo
}
export interface UnitActionData {
    [key: string]: any
    Id: number
    HeritageUnitId: number
    ActionType: number
    ActionSection: number
    FromStatus: number
    ToStatus: number
    RefType: number
    RefId: number
    Comments: string
    NewUserId: number
    NewDate: Date

    ActionTypeName: string
    ActionSectionName: string
}
export interface UnitAreaData {
    [key: string]: any
    Id: number
    UnitId: number
    ProvinceId: number
    CityId: number
    CountyId: number

    ProvinceCode: string
    ProvinceName: string
    CityCode: string
    CityName: string
    CountyCode: string
    CountyName: string
}
export interface UnitPositionData {
    [key: string]: any
    SortKey: string
    Id: number
    HeritageUnitId: number
    UnitId: number
    //1:文保单位坐标  2:监控地带 3:保护范围  4:巡查点配置 5:重点保护范围 6:碑文 7:其他
    PositionType: number
    TypeName: string
    SubSequence: number
    PositionName: string
    // 经度
    HeritageLongitude: number
    // 纬度
    HeritageLatitude: number
    // 海拔高度
    HeritageSeaHeight: number
    // 测点说明
    PositionDesc: string
    // 位置地址
    LocationAddress: string

    LngDegree: number
    LngSecond: number
    LngMinute: number

    LatDegree: number
    LatSecond: number
    LatMinute: number
    //多语言设置
    LangItems: any[]

    /**坐标点检测状态 
     * 0.Success 
     * 1.Failed 
     * 2.Province_Unmatched 
     * 3.City_Unmatched 
     * 4.County_Unmatched 
    */
    CoordStatus: number
    /**
     * 省份不一致/城市不一致/区县不一致
     */
    CoordMessage: string
    /**
     * 坐标点，对应的真实地址信息，后端通过高德地图获取后保存到数据库
     */
    CoordAddress: string
}
export interface UnitOtherData {
    [key: string]: any
    Id: number
    UnitId: number
    Tel: string
    Email: string
    Contact: string
    WebUrl: string
    WeiBo: string
    WeiXin: string
    Comments: string
}
export interface UnitAuditData {
    [key: string]: any
    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string

    ActId: number
    IsApproved: boolean
    Comments: string
}
export const getOtherUnit = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetOtherUnit(id),
    })
}
export const getUnitInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetUnitInfo(id),
    })
}
export const viewUnitInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ViewUnitInfo(id),
    })
}
export const removeUnitFile = (id: number, attachId: number) => {
    return tryAxios({
        method: 'post',
        url: DeleteUnitFile(id, attachId)
    })
}
export const checkCoord = (lng: number, lat: number) => {
    return tryAxios({
        method: 'post',
        url: CheckCoord(lng, lat)
    })
}
export const postUnitInfo = (form: UnitBaseData) => {
    return tryAxios({
        method: 'post',
        url: PostUnitInfo,
        data: form
    })
}
export const putUnitInfo = (id: number, form: UnitBaseData) => {
    return tryAxios({
        method: 'put',
        url: PutUnitInfo(id),
        data: form
    })
}
export const audit = (id: number, form: UnitAuditData) => {
    return tryAxios({
        method: 'post',
        url: AuditUnit(id),
        data: form
    })
}
export const getPartList = (listId: number) => {
    return tryAxios({
        method: 'get',
        url: GetPartList(listId),
    })
}
export const postPart = (form: UnitBaseData) => {
    return tryAxios({
        method: 'post',
        url: PostPartData,
        data: form
    })
}
export const removePart = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DeletePart(id)
    })
}
